import {useEffect, useRef, useMemo} from 'react'
import useEffectEvent from '../../hooks/use-effect-event'

const DEFAULT_PLACE_FIELDS = ['displayName', 'formattedAddress', 'location']

export default function useAutocompleteFindStoreFields(
    form,
    {onPlaceSelected, placeFields = DEFAULT_PLACE_FIELDS} = {}
) {
    const isMounted = useRef(true)
    useEffect(() => {
        return () => {
            isMounted.current = false
        }
    }, [])

    const onPlacePrediction = useEffectEvent(async (placePrediction) => {
        if (!placePrediction) return

        // Convert prediction -> place and fetch only what we need for find-store
        const place = placePrediction.toPlace()
        await place.fetchFields({fields: placeFields})

        if (!isMounted.current) return

        const name = place?.formattedAddress || place?.displayName
        if (name) {
            form.setValue('address', name, {shouldValidate: true})
        }

        if (place?.location) {
            form.setValue('latitude', place.location.lat(), {shouldValidate: false})
            form.setValue('longitude', place.location.lng(), {shouldValidate: false})
            onPlaceSelected?.(place)
            return
        }

        // fallback geocoder
        const fallbackAddress = name
        if (window.google?.maps && fallbackAddress) {
            const geocoder = new window.google.maps.Geocoder()
            geocoder.geocode({address: fallbackAddress}, (results, status) => {
                if (!isMounted.current) return
                if (status === 'OK' && results?.[0]?.geometry?.location) {
                    const location = results[0].geometry.location
                    form.setValue('latitude', location.lat(), {shouldValidate: false})
                    form.setValue('longitude', location.lng(), {shouldValidate: false})
                    onPlaceSelected?.(place)
                }
            })
        }
    })

    // into Field.inputProps
    const addressInputProps = useMemo(
        () => ({
            onPlacePrediction
        }),
        [onPlacePrediction]
    )

    return {addressInputProps}
}
